(function () {
    'use strict';
    angular.module('app').component('habilRequestStatus', {
        templateUrl: '@/status/request-status.template.html',
        bindings: {
            allStates: '<',
            allowedStates: '<',
            request: '<'
        },
        controller: RequestStatusController
    });

    RequestStatusController.$inject = ["$rootScope", "translationsService"];
    function RequestStatusController($rootScope, translationsService) {
        
        const $controller = this;

        $controller.$onInit = initialize;

        Object.defineProperty($controller, "States", { get: getListOfStates });
        function getListOfStates() {
            if (Array.isArray($controller.allStates) && $controller.allStates.length > 0)
                return $controller.allStates;

            return $rootScope.codeStatusRequestsFVM;
        }

        $controller.isCurrentStatus = (status) => $controller.request.Status == status;
        $controller.isPastStatus = function (status) {
            if (!$controller.request || !$controller.request.RequestStatusFlows)
                return false;

            const flowOrder = _.find($controller.request.RequestStatusFlows, (s) => s.StatusCode == parseInt(status));
            const currentStatus = _.find($controller.request.RequestStatusFlows, function (s) {
                if ($controller.request.Status) {
                    return s.StatusCode == $controller.request.Status;
                } else {
                    return s == $controller.request.RequestStatusFlows[$controller.request.RequestStatusFlows.length - 1];
                }
            });

            if (!currentStatus)
                return false;

            if (flowOrder === undefined)
                return false;
            return flowOrder.DateFrom < currentStatus.DateFrom;
        };

        function initialize() {
            translationsService.loadTranslations(t => { $controller.translations = t; });
        }
    }
})();
